/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCloudUsageBillingMigrationPropagation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCloudUsageBillingMigrationPropagation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCloudUsageBillingMigrationPropagation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCloudUsageBillingMigrationPropagation>): BackgroundJobPayloadForCloudUsageBillingMigrationPropagation {
        let obj = Object.assign(new BackgroundJobPayloadForCloudUsageBillingMigrationPropagation(), model);
        BackgroundJobPayloadForCloudUsageBillingMigrationPropagation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCloudUsageBillingMigrationPropagation>): BackgroundJobPayloadForCloudUsageBillingMigrationPropagation {
        if (!model) return null;
        return BackgroundJobPayloadForCloudUsageBillingMigrationPropagation.newInstance(<BackgroundJobPayloadForCloudUsageBillingMigrationPropagation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCloudUsageBillingMigrationPropagation) {
        if (!obj) return;

        models.BackgroundJobPayloadForCloudUsageBillingMigrationPropagation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCloudUsageBillingMigrationPropagation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCloudUsageBillingMigrationPropagation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
